const about = {
    title: 'Sobre Nós',
}

export default about
